import { Service, Application, HttpManager, Managers } from '@levelapp/softfabric';
import ContentType from '../Common/DTO/ContentType';


export default class ContentTypeService extends Service
{
    httpClient = Application.current.resolve<HttpManager>(Managers.HTTP_MANAGER);

    async get(onSuccess: Function, onFailure : Function = () => {})
    { 
        this.httpClient.handleSomethingWentWrong = onFailure;
        this.httpClient.handleNotFound = onFailure;
        
        this.httpClient
        .get('contentType')
        .then((response : any) => {
            if (response)
            {
                if (response.data)
                {                  
                    onSuccess(response.data.data);
                }
            }
        });
    }


    createContentType(contentType : ContentType, onSuccess: Function, onFailure : Function = () => {})
    { 
        this.httpClient.handleSomethingWentWrong = onFailure;
        this.httpClient.handleNotFound = onFailure;
        
        this.httpClient
        .post('contentType',[],contentType)
        .then((response : any) => {
            if (response)
            {
                if (response.data)
                {                  
                    onSuccess(response.data);
                }
            }
        });
    }

   
}